// Generated using typescript-generator version null on 2017-11-17 16:17:27.

import {Observable} from "rxjs/Rx";
import {Injectable} from "@angular/core";

export class AuthenticationResponseDto implements Dto {
  login: string;
  cookieValue: string;
}

export class UserInformations {
  id: string;
  login: string;
  prenom: string;
  nom: string;
  telephone: string;
  role: UserRole;
  metadata: { [index: string]: any };
  lang: Locale;
  modules: string[];
  correspondants: Correspondant[];
  date: any;
  expires: any;
  origine: string;
  url: string;
  properties: { [index: string]: any };
  'e-mail': string;
  daysBeforeExpire: number | undefined | null;
  firstConnection: boolean | undefined | null;
}

export class TokenDto extends UserInformations implements Dto {
  token: string;
  cookie: string;
  maxUse: number;
  count: number;
  expireDays: number;
}

export class TokenResponseDto extends TokenDto {
  tokenCreationDate: any;
}

export class AuthenticationDto implements Dto {
  login: string;
  password: string;
}

export class ModuleAuthenticationDto implements Dto {
  moduleId: string;
  password: string;
}

export class ModuleAuthenticationResponseDto implements Dto {
  moduleId: string;
  cookieValue: string;
}

export class TagSearchCriteria {
  enable: boolean;
}

export class CorrespondantDetails {
  code: string;
  nom: string;
  service: string;
  adressePrincipale: Adresse;
  adresseLivraison: Adresse;
  telephone: string;
  fax: string;
  email: string;
  numFiness: string;
  numAdeli: string;
  codeRpps: string;
  typeCarte: string;
  langue: Locale;
  correspondantParent: string;
}

export class UserSearchCriteria {
  tags: string[];
  roles: UserRole[];
}

export class KeyDto {
  key: string;
}

export interface Dto {
}

export class Locale implements Cloneable, Serializable {
}

export class Correspondant {
  code: string;
  nom: string;
  tags: string[];
  dateDesactivation: any;
  metadata: { [index: string]: any };
}

export class CorrespondantDto implements Dto {
  code: string;
  nom: string;
  tags: string[];
}

export class TagDto implements Dto {
  id: number;
  enabled: boolean;
  nomtechnique: string;
  label_en: string;
  label_fr: string;
  position: number;
  categorie: string;
}

export class Adresse {
  ligne1: string;
  ligne2: string;
  ligne3: string;
  codePostal: string;
  ville: string;
  pays: string;
}

export interface Cloneable {
}

export interface Serializable {
}

export abstract class HttpClient {

  abstract request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

@Injectable()
export class IAuthenticationPublicWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * guest
   * Response code 200 - Connexion de l'utilisateur Guest rÃ©alisÃ©e avec succÃ¨s
   * HTTP GET /public/guest
   * Java method: fr.cerba.digicerba.authentification.webservices.IAuthenticationPublicWebService.guest
   */
  guest(queryParams?: { lang?: string; }): RestResponse<AuthenticationResponseDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`public/guest`, queryParams: queryParams});
  }

  /**
   * validateToken
   * Response code 200 - Le token est validÃ©
   * HTTP GET /public/token/validate
   * Java method: fr.cerba.digicerba.authentification.webservices.IAuthenticationPublicWebService.validateToken
   */
  validateToken(queryParams?: { token?: string; }): RestResponse<TokenResponseDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`public/token/validate`, queryParams: queryParams});
  }
}

@Injectable()
export class IAuthenticationWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * login
   * Response code 200 - Connexion de l'utilisateur rÃ©alisÃ©e avec succÃ¨s
   * HTTP POST /login
   * Java method: fr.cerba.digicerba.authentification.webservices.IAuthenticationWebService.login
   */
  login(arg0: AuthenticationDto): RestResponse<AuthenticationResponseDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`login`, data: arg0});
  }

  /**
   * logout
   * Response code 200 - DÃ©connexion de l'utilisateur rÃ©alisÃ©e avec succÃ¨s
   * HTTP POST /logout
   * Java method: fr.cerba.digicerba.authentification.webservices.IAuthenticationWebService.logout
   */
  logout(): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`logout`});
  }

  /**
   * reset
   * Response code 200 - Demande de mot de passe rÃ©alisÃ©e avec succÃ¨s
   * HTTP POST /reset
   * Java method: fr.cerba.digicerba.authentification.webservices.IAuthenticationWebService.reset
   */
  reset(queryParams?: { email?: string; }): RestResponse<boolean> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`reset`, queryParams: queryParams});
  }
}

@Injectable()
export class ICorrespondantWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * correspondants/all
   * Response code 200 - RÃ©cupÃ©ration des correspondants rÃ©alisÃ©e avec succÃ¨s
   * HTTP GET /correspondants/all
   * Java method: fr.cerba.digicerba.authentification.webservices.ICorrespondantWebService.getAllCorrespondants
   */
  getAllCorrespondants(queryParams?: { enable?: boolean; }): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondants/all`, queryParams: queryParams});
  }
}

@Injectable()
export class IModuleWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * loginModule
   * Response code 200 - L'authentification du module a Ã©tÃ© rÃ©alisÃ©e avec succÃ¨s
   * HTTP POST /sso/login-module
   * Java method: fr.cerba.digicerba.authentification.webservices.IModuleWebService.loginModule
   */
  loginModule(arg0: ModuleAuthenticationDto): RestResponse<ModuleAuthenticationResponseDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`sso/login-module`, data: arg0});
  }
}

@Injectable()
export class IPageTokenWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * createToken
   * Response code 200 - Le token de page est crÃ©Ã©
   * HTTP POST /page/token/create
   * Java method: fr.cerba.digicerba.authentification.webservices.IPageTokenWebService.createToken
   */
  createToken(arg0: TokenDto): RestResponse<TokenResponseDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`page/token/create`, data: arg0});
  }

  /**
   * deleteToken
   * Response code 200 - Le token de page est supprimÃ©
   * HTTP POST /page/token/delete
   * Java method: fr.cerba.digicerba.authentification.webservices.IPageTokenWebService.deleteToken
   */
  deleteToken(arg0: string): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`page/token/delete`, data: arg0});
  }

  /**
   * getToken
   * Response code 200 - Le token est retounÃ©
   * HTTP GET /page/token/get
   * Java method: fr.cerba.digicerba.authentification.webservices.IPageTokenWebService.getToken
   */
  getToken(queryParams?: { token?: string; }): RestResponse<TokenResponseDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`page/token/get`, queryParams: queryParams});
  }
}

@Injectable()
export class ITagWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * all
   * Response code 200 - RÃ©cupÃ©ration de la listes des tags
   * HTTP POST /tags/all
   * Java method: fr.cerba.digicerba.authentification.webservices.ITagWebService.getAllTags
   */
  getAllTags(arg0: TagSearchCriteria): RestResponse<TagDto[]> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`tags/all`, data: arg0});
  }
}

@Injectable()
export class IUsurpationWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * loginAs
   * Response code 200 - L'usurpation a Ã©tÃ© mise en place. Retourne la nouvelle valeur de cookie CERBA_AUTHENTIFICATION
   * HTTP GET /sso/login-as/{login}
   * Java method: fr.cerba.digicerba.authentification.webservices.IUsurpationWebService.loginAs
   */
  loginAs(login: string): RestResponse<UserInformations> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`sso/login-as/${login}`});
  }

  /**
   * logoutAs
   * Response code 200 - L'usurpation a Ã©tÃ© supprimÃ©e. Retourne la nouvelle valeur du cookie CERBA_AUTHENTIFICATION
   * HTTP GET /sso/logout-as
   * Java method: fr.cerba.digicerba.authentification.webservices.IUsurpationWebService.logoutAs
   */
  logoutAs(): RestResponse<UserInformations> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`sso/logout-as`});
  }
}

@Injectable()
export class IUtilisateurInsertWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Creation d'un correspondant
   * Response code 200 - CrÃ©ation de l'utilisateur rÃ©alisÃ©e avec succÃ¨s
   * HTTP POST /public/dev/create/correspondant
   * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurInsertWebService.createCorrespondant
   */
  createCorrespondant(arg0: CorrespondantDetails): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`public/dev/create/correspondant`, data: arg0});
  }

  /**
   * Creation d'un utilisateur
   * Response code 200 - CrÃ©ation de l'utilisateur rÃ©alisÃ©e avec succÃ¨s
   * HTTP POST /public/dev/create/user
   * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurInsertWebService.createUser
   */
  createUser(arg0: UserInformations): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`public/dev/create/user`, data: arg0});
  }

  /**
   * Initialisation
   * Response code 200 - Initialisation rÃ©alisÃ©e avec succÃ¨s
   * HTTP GET /public/dev/create/init
   * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurInsertWebService.init
   */
  init(): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`public/dev/create/init`});
  }
}

@Injectable()
export class IUtilisateurWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * getCorrespondantDetails
   * Response code 200 - RÃ©cupÃ©ration du dÃ©tail d'un correspondant rÃ©alisÃ©e avec succÃ¨s
   * HTTP GET /correspondant/{code}
   * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurWebService.getCorrespondantDetails
   */
  getCorrespondantDetails(code: string): RestResponse<CorrespondantDetails> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/${code}`});
  }

  /**
   * informations
   * Response code 200 - RÃ©cupÃ©ration de l'utilisateur rÃ©alisÃ©e avec succÃ¨s
   * HTTP GET /user/{login}
   * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurWebService.informations
   */
  informations(login: string): RestResponse<UserInformations> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`user/${login}`});
  }

  /**
   * getCorrespondantDetails
   * Response code 200 - RÃ©cupÃ©ration des utilisateurs correspondants aux critÃ¨res rÃ©alisÃ©e avec succÃ¨s
   * HTTP POST /user/search
   * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurWebService.searchUsers
   */
  searchUsers(arg0: UserSearchCriteria): RestResponse<UserInformations[]> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`user/search`, data: arg0});
  }
}

@Injectable()
export class ICryptoWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * key
   * Response code 200 - Renvoi de la clÃ© publique avec succÃ¨s
   * Response code 500 - Erreur interne lors de la rÃ©cupÃ©ration de la clÃ© privÃ©e
   * HTTP GET /sso/crypto/key
   * Java method: fr.cerba.digicerba.security.crypto.server.ICryptoWebService.key
   */
  key(): RestResponse<KeyDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`sso/crypto/key`});
  }
}

export type RestResponse<R> = Observable<R>;

export type UserRole =
  'COMPTE_LIE'
  | 'INVITE'
  | 'ANCIEN_COMPTE'
  | 'ADMINISTRATEUR'
  | 'RESPONSABLE'
  | 'MODULE'
  | 'PROSPECT';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '/authentification/api/';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/resources/auth/resources.auth.ts